import React from 'react'
// import { Document, Page } from 'react-pdf'

const PositiveThinkingCanChangeOurLife = () => (

  <div>
    <link href='http://oaji.net/articles/2015/1170-1428504527.pdf'></link>

  </div>
)

export default PositiveThinkingCanChangeOurLife



// WEBPACK FOOTER //
// ./src/components/Article/PositiveThinkingCanChangeOurLife/PositiveThinkingCanChangeOurLife.js